import React from 'react';
import { useStyletron } from 'baseui';
import type { MediaState, PlaybackState } from '../../../../common/player-controls/types';
import { MediaSettings } from './media-settings';
import { PlaybackControls } from './playback-controls';
type FramesControlsM4Props = {
  playback: PlaybackState;
  media: MediaState;
  isDisabled?: boolean;
  isMultiVideoIndex: boolean;
};
export const FramesControlsM4 = ({
  playback,
  media,
  isDisabled,
  isMultiVideoIndex
}: FramesControlsM4Props) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    borderTop: `${theme.sizing.scale0} solid ${theme.colors.borderOpaque}`,
    borderBottom: `${theme.sizing.scale0} solid ${theme.colors.borderOpaque}`,
    backgroundColor: theme.colors.backgroundPrimary,
    padding: `${theme.sizing.scale200} ${theme.sizing.scale500}`
  })}>
      <PlaybackControls isPlaying={playback.isPlaying} togglePlayback={playback.togglePlayback} currentFrame={playback.currentFrame} maxFrames={playback.maxFrames} imageLoadStatus={playback.imageLoadStatus} onFrameChange={playback.onFrameChange} isVideoPlayer={playback.isVideoPlayer} isDisabled={isDisabled} isMultiVideoIndex={isMultiVideoIndex} mediaElement={playback.mediaElement} timeDisplayMode={media.timeDisplayMode} frameRate={media.frameRate} />

      <MediaSettings playSpeed={media.playSpeed} setPlaySpeed={media.setPlaySpeed} mediaVolume={media.mediaVolume} onMediaVolumeChange={media.onMediaVolumeChange} timeDisplayMode={media.timeDisplayMode} setTimeDisplayMode={media.setTimeDisplayMode} currentFrame={playback.currentFrame} maxFrames={playback.maxFrames} frameRate={media.frameRate} onFrameChange={playback.onFrameChange} isMultiVideoIndex={isMultiVideoIndex} />
    </div>;
};